import { Stack, Typography } from '@common-components';
import { AutoAwesomeOutlined } from '@icons';
import { messages } from 'i18n';

export default function ComingSoonSection() {
  return (
    <Stack direction="row" alignItems="center" gap={1} p={2} bgcolor="blueGrey.50" borderRadius={2}>
      <AutoAwesomeOutlined color="primary" fontSize="small" />
      <Typography variant="body2" color="primary">
        {messages.carrierSubmissionWorkspace.comingSoon}
      </Typography>
    </Stack>
  );
}
